import {Component, OnInit, ViewChild} from '@angular/core';
import {FileService} from "@wms/services";
import { isArray, isEqual} from "lodash-es";
import {runtimeEventManager, stringEndsWith} from "@wm/core";
import { CommonModule } from "@angular/common";
import {Config, isNonEmptyString, NewProps, PrefabConfigurationService} from "@wms/settings/prefab-config";
import {FormsModule, NgForm} from "@angular/forms";
import {Subscription} from "rxjs";
import { BasePrefabConfigTab } from '../base-tab-component/base-prefabconfig-tab-component.component';

@Component({
  selector: 'wms-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.less'],
  imports: [
    CommonModule,
    FormsModule
  ],
  standalone: true
})
export class ResourcesComponent extends BasePrefabConfigTab implements OnInit {
  allScripts  : any[];
  allStyles   : any[];
  newProps    : NewProps;
  formChangesSubscription: Subscription;
  @ViewChild('resourcesForm', {static: true}) override resourcesForm: NgForm;

  constructor(private fileService: FileService) {
    super();
    this.newProps     = this.prefabConfigService.newProps;
    this.prefabConfig = this.prefabConfigService.getConfig();
    this.prefabConfig.resources = {
      styles  : this.prefabConfig.resources?.styles || [],
      scripts : this.prefabConfig.resources?.scripts || []
    };
    this.getScriptAndStyleFiles();
    this.registerDestroyListener.add(runtimeEventManager.on('prepare-resources-save').subscribe(() => this.prepareForSave()));
  }

  ngOnInit() {
    let setInitialValue: boolean = true;
    if (this.initialResources) {        
      setInitialValue = false;
    }
    this.formChangesSubscription = this.resourcesForm.form.valueChanges?.subscribe(() => {
      if (!this.resourcesForm.form.dirty && setInitialValue) {
        this.initialResources = this.resourcesForm.form.value;
      } 
      this.prefabConfigService.isInvalid['resources'] = this.resourcesForm.form.invalid;
      if(this.resourcesForm.form.dirty && !isEqual(this.initialResources,this.resourcesForm.form.value)){
        this.setDirty()
      }

      if (this.resourcesForm.form.dirty) {
        if (isEqual(this.initialResources, this.resourcesForm.form.value)) {
          delete this.prefabConfigService.isDirty['resources'];
        } else if ('provider' in this.prefabConfigService.isDirty) {
          this.setDirty()
        }
      }
    });
  }

  setDirty() {
    this.prefabConfigService.isDirty['resources'] = true;
  }

  prepareForSave() {
    let prefabConfig: Config = this.prefabConfigService.getConfig();
    prefabConfig.resources.styles = prefabConfig.resources.styles.filter(isNonEmptyString);
    prefabConfig.resources.scripts = prefabConfig.resources.scripts.filter(isNonEmptyString);
  }

  getFileNames(files: any) {
    if (files.type === 'folder' && isArray(files.files)) {
      if (files.path !== '/data' && files.path !== '/pages' && files.path !== '/resources/ngLocale') {
        files.files.forEach((item: any) => {
          this.getFileNames(item);
        });
      }
    } else {
      if (stringEndsWith(files.name, '.js')) {
        this.allScripts.push(files.path);
      }
      if (stringEndsWith(files.name, '.css')) {
        this.allStyles.push(files.path);
      }
    }
  }

  getScriptAndStyleFiles() {
    this.fileService.readDir('').then(files => {
      this.allScripts = [];
      this.allStyles  = [];
      this.getFileNames(files);
    });
  }

  removeStyle(index: number) {
    this.prefabConfig.resources.styles.splice(index, 1);
    this.setDirty();
  }

  addStyle() {
    if (!this.newProps.style) {
      return;
    }
    this.prefabConfig.resources.styles.push(this.newProps.style);
    this.newProps.style = '';
  }

  removeScript(index: number) {
    this.prefabConfig.resources.scripts.splice(index, 1);
    this.setDirty();
  }

  addScript() {
    if (!this.newProps.script) {
      return;
    }
    this.prefabConfig.resources.scripts.push(this.newProps.script);
    this.newProps.script = '';
  }

   override ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }
}
